import { getPreset } from "@/lib/journal-presets";

/**
 * Renders a branded featured-image preset for posts without a custom image.
 * Reused on listing cards, hero on post pages, and the admin preset picker.
 */
export default function PresetHero({ presetId, title, className = "", showCaption = true }) {
  const preset = getPreset(presetId);
  if (!preset) return null;
  return (
    <div
      className={`relative w-full h-full flex items-end p-6 ${className}`}
      style={preset.style}
      data-testid={`preset-hero-${preset.id}`}
      aria-label={preset.label}
    >
      {/* Wordmark chip */}
      <div
        className="absolute top-4 left-4 text-[10px] tracking-[0.14em] uppercase"
        style={{ color: preset.accent, fontFamily: "'Geist Mono', monospace" }}
      >
        The Reliserve Wealth Journal
      </div>
      {showCaption && (
        <div
          className="font-display text-lg md:text-2xl leading-tight max-w-[80%]"
          style={{ color: preset.darkText ? "#16233D" : "#FFFFFF" }}
        >
          {title || preset.caption}
        </div>
      )}
    </div>
  );
}
